import { render, staticRenderFns } from "./PaginationTrigger.vue?vue&type=template&id=f5dbfb78&"
import script from "./PaginationTrigger.vue?vue&type=script&lang=js&"
export * from "./PaginationTrigger.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports